import { TypedNode } from "../_Base";
import { NodeContext } from "../../poly/NodeContext";
import { MapUtils } from "../../../core/MapUtils";
import { Poly } from "../../Poly";
export class TypedEventNode extends TypedNode {
  constructor() {
    super(...arguments);
    this._cookWithoutInputsBound = this._cookWithoutInputs.bind(this);
  }
  static context() {
    return NodeContext.EVENT;
  }
  initializeBaseNode() {
    this.uiData.setLayoutHorizontal();
    this.addPostDirtyHook("cookWithoutInputsOnDirty", this._cookWithoutInputsBound);
    this.io.inputs.setDependsOnInputs(false);
    this.io.connections.initInputs();
    this.io.connection_points.spare_params.initializeNode();
  }
  _cookWithoutInputs() {
    this.cookController.cookMainWithoutInputs();
  }
  cook() {
    this.cookController.endCook();
  }
  processEventViaConnectionPoint(eventContext, connectionPoint) {
    if (connectionPoint.event_listener) {
      connectionPoint.event_listener(eventContext);
    } else {
      this.processEvent(eventContext);
    }
  }
  processEvent(event_context) {
  }
  async dispatchEventToOutput(output_name, event_context) {
    this.run_on_dispatch_hook(output_name, event_context);
    const index = this.io.outputs.getOutputIndex(output_name);
    if (index >= 0) {
      const outputConnections = this.io.connections.outputConnectionsByOutputIndex(index);
      if (outputConnections) {
        let destNode;
        if (!Poly.playerMode()) {
          const dispatcher = this.scene().eventsDispatcher.connectionTriggerDispatcher;
          outputConnections.forEach((connection) => {
            dispatcher.dispatchTrigger(connection);
          });
        }
        outputConnections.forEach((connection) => {
          destNode = connection.node_dest;
          const connection_point = destNode.io.inputs.namedInputConnectionPoints()[connection.input_index];
          destNode.processEventViaConnectionPoint(event_context, connection_point);
        });
      }
    } else {
      console.warn(`requested output '${output_name}' does not exist on node '${this.path()}'`);
    }
  }
  onDispatch(outputName, callback) {
    this._on_dispatch_hooks_by_output_name = this._on_dispatch_hooks_by_output_name || /* @__PURE__ */ new Map();
    MapUtils.pushOnArrayAtEntry(this._on_dispatch_hooks_by_output_name, outputName, callback);
  }
  run_on_dispatch_hook(output_name, event_context) {
    if (this._on_dispatch_hooks_by_output_name) {
      const hooks = this._on_dispatch_hooks_by_output_name.get(output_name);
      if (hooks) {
        for (let hook of hooks) {
          hook(event_context);
        }
      }
    }
  }
}
export class BaseEventNodeClass extends TypedEventNode {
}
